import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects"

import {
  ADD_LEAD_APPLICANT,
  ADD_LEAD_BUSINESS_ENTITY,
  ADD_LEAD_HOME,
  ADD_LEAD_REFUND,
  ADD_LEAD_VEHICLE,
  ADD_LEAD_VIOLATION,
  DELETE_LEAD_APPLICANT,
  DELETE_LEAD_BUSINESS_ENTITY,
  DELETE_LEAD_HOME,
  DELETE_LEAD_REFUND,
  DELETE_LEAD_VEHICLE,
  DELETE_LEAD_VIOLATION,
  GET_LEADS, GET_LEAD_BY_ID, GET_LEAD_BY_QUOTE_CALL_ID, GET_LEAD_REFUND_REASONS, UPDATE_LEAD, UPDATE_LEAD_APPLICANT, UPDATE_LEAD_BUSINESS_ENTITY, UPDATE_LEAD_DETAILS, UPDATE_LEAD_HOME, UPDATE_LEAD_VEHICLE, UPDATE_LEAD_VIOLATION,
  GET_LEAD_DETAILS_EXPORT,
} from "./actionTypes"

import {
  getLeadsSuccess,
  getLeadsError,
  getLeadByIdSuccess,
  getLeadByIdError,
  getLeadByQuoteCallIdSuccess,
  getLeadByQuoteCallIdError,
  updateLeadDetailsSuccess,
  updateLeadDetailsError,
  addLeadHomeSuccess,
  addLeadHomeError,
  addLeadViolationSuccess,
  addLeadViolationError,
  addLeadRefundSuccess,
  addLeadRefundError,
  deleteLeadRefundSuccess,
  deleteLeadRefundError,
  updateLeadSuccess,
  updateLeadError,
  getLeadDetailReportSuccess,
  getLeadDetailReportError
} from "./actions"

import {
  fetchCSVLeadDetail,
  genericDeleteRequest,
  genericGetRequest, genericGetRequest_2, genericPostRequest, genericPutRequest,
} from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { addLeadVehicleError, addLeadVehicleSuccess, deleteLeadVehicleError, deleteLeadVehicleSuccess, updateLeadVehicleError, updateLeadVehicleSuccess } from "./lead_vehicles_actions"
import { addLeadBusinessEntityError, addLeadBusinessEntitySuccess, deleteLeadBusinessEntityError, deleteLeadBusinessEntitySuccess, updateLeadBusinessEntityError, updateLeadBusinessEntitySuccess } from "./lead_business_entity_actions"
import { deleteLeadHomeError, deleteLeadHomeSuccess, updateLeadHomeError, updateLeadHomeSuccess } from "./lead_homes_actions"
import { deleteLeadViolationError, deleteLeadViolationSuccess, updateLeadViolationError, updateLeadViolationSuccess } from "./lead_violations_actions"
import { addLeadApplicantError, addLeadApplicantSuccess, deleteLeadApplicantError, deleteLeadApplicantSuccess, updateLeadApplicantError, updateLeadApplicantSuccess } from "./lead_applicants_actions"
import { getLeadRefundReasonsError, getLeadRefundReasonsSuccess } from "./lead_refund_reasons_actions"
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert"
import { buildCampaignAnalysisCacheKey } from "helpers/sf_utils"

const inFlightLeadsRequests = new Set()

function* onGetLeads(action) {
  try {
    const useCache = Boolean(action.payload?.useCache)
    const queryParams = action.payload?.queryParams || {}
    const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
    const cacheKey = useCache ? buildCampaignAnalysisCacheKey(queryParams) : null
    const requestKey = `${cacheKey}:${requestedPageNumber}`
    const cachedPage = useCache
      ? yield select((state) => state.Leads.page_cache?.[cacheKey]?.[requestedPageNumber])
      : null

    if (useCache && cachedPage) {
      return
    }

    if (useCache && inFlightLeadsRequests.has(requestKey)) {
      return
    }

    if (useCache) {
      inFlightLeadsRequests.add(requestKey)
    }

    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/leads`, //Check endpoint
      { ...queryParams || "" },
      {
        Authorization: user.token,
        'account-id': user.account_id,
      }
    )
    yield put(getLeadsSuccess(response, {
      queryParams,
      useCache,
      replaceResults: Boolean(action.payload?.replaceResults),
    }))
  } catch (error) {
    yield put(getLeadsError(error))
  } finally {
    if (action.payload?.useCache) {
      const queryParams = action.payload?.queryParams || {}
      const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
      const cacheKey = buildCampaignAnalysisCacheKey(queryParams)
      inFlightLeadsRequests.delete(`${cacheKey}:${requestedPageNumber}`)
    }
  }
}

// Fetch All Campaign By Id
function* onGetLeadById(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/leads/${action.payload.id}`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getLeadByIdSuccess(response))
  } catch (error) {
    yield put(getLeadByIdError(error))
  }
}

function* onGetLeadByQuoteCallId(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/quote_call_parsed_leads/${action.payload.id}`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getLeadByQuoteCallIdSuccess(response))
  } catch (error) {
    yield put(getLeadByQuoteCallIdError(error))
  }
}

function* onUpdateLead(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/leads/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateLeadSuccess(response))
  } catch (error) {
    yield put(updateLeadError(error))
  }
}

function* onUpdateLeadDetails(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_details/${lead?.payload?.lead_details?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateLeadDetailsSuccess(response))
  } catch (error) {
    yield put(updateLeadDetailsError(error))
  }
}

function* onAddLeadVehicle(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_vehicles`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addLeadVehicleSuccess(response))
  } catch (error) {
    yield put(addLeadVehicleError(error))
  }
}

function* onAddLeadHome(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_homes`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addLeadHomeSuccess(response))
  } catch (error) {
    yield put(addLeadHomeError(error))
  }
}

function* onAddLeadBusinessEntity(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_business_entities`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addLeadBusinessEntitySuccess(response))
  } catch (error) {
    yield put(addLeadBusinessEntityError(error))
  }
}

function* onAddLeadViolation(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_violations`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addLeadViolationSuccess(response))
  } catch (error) {
    yield put(addLeadViolationError(error))
  }
}

function* onAddLeadApplicant(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_applicants`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addLeadApplicantSuccess(response))
  } catch (error) {
    yield put(addLeadApplicantError(error))
  }
}


function* onAddLeadRefund(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_refunds`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addLeadRefundSuccess(response))
  } catch (error) {
    yield put(addLeadRefundError(error))
  }
}



function* onUpdateLeadVehicle(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_vehicles/${lead?.payload?.lead_vehicle?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateLeadVehicleSuccess(response))
  } catch (error) {
    yield put(updateLeadVehicleError(error))
  }
}

function* onUpdateLeadApplicant(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_applicants/${lead?.payload?.lead_applicant?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateLeadApplicantSuccess(response))
  } catch (error) {
    yield put(updateLeadApplicantError(error))
  }
}

function* onUpdateLeadHome(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_homes/${lead?.payload?.lead_home?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateLeadHomeSuccess(response))
  } catch (error) {
    yield put(updateLeadHomeError(error))
  }
}

function* onUpdateLeadViolation(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_violations/${lead?.payload?.lead_violation?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateLeadViolationSuccess(response))
  } catch (error) {
    yield put(updateLeadViolationError(error))
  }
}

function* onUpdateLeadBusinessEntity(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_business_entities/${lead?.payload?.lead_business_entity?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateLeadBusinessEntitySuccess(response))
  } catch (error) {
    yield put(updateLeadBusinessEntityError(error))
  }
}

function* onDeleteLeadVehicle(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_vehicles/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteLeadVehicleSuccess(response))
  } catch (error) {
    yield put(deleteLeadVehicleError(error))
  }

}

function* onDeleteLeadHome(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_homes/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteLeadHomeSuccess(response))
  } catch (error) {
    yield put(deleteLeadHomeError(error))
  }
}

function* onDeleteLeadBusinessEntity(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_business_entities/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteLeadBusinessEntitySuccess(response))
  } catch (error) {
    yield put(deleteLeadBusinessEntityError(error))
  }
}

function* onDeleteLeadViolation(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_violations/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteLeadViolationSuccess(response))
  } catch (error) {
    yield put(deleteLeadViolationError(error))
  }
}

function* onDeleteLeadRefund(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_refunds/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteLeadRefundSuccess(response))
  } catch (error) {
    yield put(deleteLeadRefundError(error))
  }
}

function* onDeleteLeadApplicant(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_applicants/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteLeadApplicantSuccess(response))
  } catch (error) {
    yield put(deleteLeadApplicantError(error))
  }
}

// Fetch All Lead Refund Reasons
function* onGetLeadRefundReasons(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_refund_reasons`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getLeadRefundReasonsSuccess(response))
  } catch (error) {
    yield put(getLeadRefundReasonsError(error))
  }
}

function* onLeadDetailExport(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let lead_id = action?.payload?.queryParams?.lead_id
    const response = yield call(
      fetchCSVLeadDetail,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_detail_export/${lead_id}`,
      action.payload?.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id

      },
      action?.filename
    )
    const res = { status: response.status };
    if(response.status === 200)
    {
      yield put(getLeadDetailReportSuccess(res, action?.filename))
    } else {
      ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: "Something went wrong!" })
      yield put(getLeadDetailReportError(res))
    }
  } catch (error) {
    yield put(getLeadDetailReportError(error))
  }
}


function* LeadsSaga() {
  yield takeLatest(GET_LEADS, onGetLeads)
  yield takeEvery(GET_LEAD_BY_ID, onGetLeadById)
  yield takeEvery(GET_LEAD_BY_QUOTE_CALL_ID, onGetLeadByQuoteCallId)
  yield takeEvery(UPDATE_LEAD_DETAILS, onUpdateLeadDetails)
  yield takeEvery(UPDATE_LEAD, onUpdateLead)
  yield takeEvery(ADD_LEAD_VEHICLE, onAddLeadVehicle)
  yield takeEvery(UPDATE_LEAD_VEHICLE, onUpdateLeadVehicle)
  yield takeEvery(DELETE_LEAD_VEHICLE, onDeleteLeadVehicle)
  yield takeEvery(ADD_LEAD_HOME, onAddLeadHome)
  yield takeEvery(UPDATE_LEAD_HOME, onUpdateLeadHome)
  yield takeEvery(DELETE_LEAD_HOME, onDeleteLeadHome)
  yield takeEvery(ADD_LEAD_BUSINESS_ENTITY, onAddLeadBusinessEntity)
  yield takeEvery(UPDATE_LEAD_BUSINESS_ENTITY, onUpdateLeadBusinessEntity)
  yield takeEvery(DELETE_LEAD_BUSINESS_ENTITY, onDeleteLeadBusinessEntity)
  yield takeEvery(ADD_LEAD_VIOLATION, onAddLeadViolation)
  yield takeEvery(UPDATE_LEAD_VIOLATION, onUpdateLeadViolation)
  yield takeEvery(DELETE_LEAD_VIOLATION, onDeleteLeadViolation)
  yield takeEvery(ADD_LEAD_APPLICANT, onAddLeadApplicant)
  yield takeEvery(UPDATE_LEAD_APPLICANT, onUpdateLeadApplicant)
  yield takeEvery(DELETE_LEAD_APPLICANT, onDeleteLeadApplicant)
  yield takeEvery(ADD_LEAD_REFUND, onAddLeadRefund)
  yield takeEvery(DELETE_LEAD_REFUND, onDeleteLeadRefund)
  yield takeEvery(GET_LEAD_REFUND_REASONS, onGetLeadRefundReasons)
  yield takeEvery(GET_LEAD_DETAILS_EXPORT, onLeadDetailExport)
}

export default LeadsSaga

